module.exports = __webpack_public_path__ + "media/src/images/icons/arrow-back-3624a59d388404452f6c4752cd596c8f.svg";